import React from 'react';

import PropTypes from 'prop-types';

import { Grid } from '@mui/material';

import BoxRenderer from '../BoxRenderer';

export const OutputsRenderer = ({ boxes }) => {
    const getGridSize = (count) => {
        if (count === 1) return 12;
        if (count === 2) return 6;
        return 6;
    };

    const gridSize = getGridSize(boxes.length);

    return (
        <Grid container spacing={2}>
            {boxes.map((box, index) => (
                <Grid item xs={12} sm={gridSize} md={gridSize} key={index}>
                    <BoxRenderer box={box} />
                </Grid>
            ))}
        </Grid>
    );
};

OutputsRenderer.propTypes = {
    boxes: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            columns: PropTypes.arrayOf(
                PropTypes.shape({
                    column_order: PropTypes.number.isRequired,
                    column_type: PropTypes.string,
                    rows: PropTypes.arrayOf(
                        PropTypes.shape({
                            row_order: PropTypes.number.isRequired,
                            cell_type: PropTypes.string,
                            cell_row_type: PropTypes.string,
                            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                            formatted_value: PropTypes.string,
                            cell: PropTypes.string
                        })
                    ).isRequired
                })
            ).isRequired
        })
    ).isRequired
};
